import React, { useState } from 'react';
import './ContactUs.css';
import gridImage from '../background/grid.avif'; // Import the image correctly

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://japanotakuex.darkleaguestudios.com/contactForm.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString(),
      });

      const result = await response.text();
      alert(result);
      setFormData({ name: '', email: '', message: '' }); // Reset form
    } catch (error) {
      alert('There was an error sending your message.');
    }
  };

  return (
    <section className="contact-us-section" style={{ backgroundImage: `url(${gridImage})` }}>
      <div className="contact-form">
        <h2>CONTACT US</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">YOUR NAME</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">EMAIL ADDRESS</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">YOUR MESSAGE</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit">SEND MESSAGE</button>
        </form>
      </div>
    </section>
  );
};

export default ContactUs;
